export const abnNoticeConstants = {
  templateType: {
    ABN_Medicare: "ABN_Medicare",
    ABN_Commercial: "ABN_Commercial",
  },
  abnOption: {
    billMedicare: "billMedicare",
    selfPay: "selfPay",
    declineService: "declineService",
  },
};

export const abnOptionMapping = {
  [abnNoticeConstants.abnOption.billMedicare]: "BillMedicare",
  [abnNoticeConstants.abnOption.selfPay]: "SelfPay",
  [abnNoticeConstants.abnOption.declineService]: "DeclineService",
};
